(() => {
  const key = 'fxl-recent-products';
  const initialized = new WeakSet();
  const initialize = scope => {
    scope.querySelectorAll('.fxl-recently-viewed').forEach(async section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const grid = section.querySelector('.fxl-recently-viewed__grid');
      const current = section.dataset.currentProduct;
      let handles = [];
      try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch {}
      handles = Array.isArray(handles) ? handles.filter(value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value)) : [];
      if (current) { try { localStorage.setItem(key, JSON.stringify([current, ...handles.filter(handle => handle !== current)].slice(0,30))); } catch {} }
      const selected = handles.filter(handle => handle !== current).slice(0, Number(grid.dataset.number_of_items) || 8);
      if (!selected.length) { section.hidden = true; return; }
      const results = await Promise.allSettled(selected.map(async handle => {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}?view=fxl-card`);
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.fxl-product-card');
      }));
      for (const result of results) if (result.status === 'fulfilled' && result.value) grid.append(result.value);
      section.hidden = !grid.children.length;
      const previous = section.querySelector('[data-fxl-recently-prev]');
      const next = section.querySelector('[data-fxl-recently-next]');
      const update = () => {
        const overflow = grid.scrollWidth > grid.clientWidth + 4;
        previous?.classList.toggle('is-visible', overflow);
        next?.classList.toggle('is-visible', overflow);
      };
      previous?.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' }));
      next?.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' }));
      new ResizeObserver(update).observe(grid);
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', () => initialize(document));
})();
